import React from "react";
import MyIcon from "../MyIcon";
import ImportIcon from "../../../assets/icons/import-01.svg2";

export default function DragDropAFile() {
  return (
    <div
      className=" align-items-center rounded-3 py-4 mt-5 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 border-2 border-purple "
      style={{ border: "dashed 5px" }}
    >
      <div className="d-flex flex-column align-items-center p-5">
        <div>
          <MyIcon Icon={ImportIcon} width={70} className="me-2"  />
        </div>
        <div className="fw-bold mt-4 ">Drag & Drop a file here or click</div>

        
      </div>
    </div>
  );
}
